export default function headers() {
  const header = {
    Language: localStorage.getItem("lan"),
    "Access-Control-Allow-Origin":"*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"

  };
  return header;
}
